import { GetPatientDetailsSchema } from '@montugroup/pms-api-contracts';
import { z } from 'zod';

export const schema = GetPatientDetailsSchema.shape.identificationInfo
  .unwrap()
  .shape.attributes.pick({
    ihiNumber: true,
    ihiNumberStatus: true,
    ihiRecordStatus: true
  })
  .partial()
  .extend({
    ihiNumber: z
      .string({ message: 'IHI number is required.' })
      .transform((number) => number.trim())
      .refine((number) => /^[0-9]{16}$/.test(number), {
        message: 'IHI number must be exactly 16 digits long and contain only numbers.'
      })
      .nullable()
      .optional()
  });

export type IhiInformationFormFields = z.infer<typeof schema>;
